import { render, staticRenderFns } from "./study-participant-messages.vue?vue&type=template&id=494aee5e&scoped=true&"
import script from "./study-participant-messages.vue?vue&type=script&lang=js&"
export * from "./study-participant-messages.vue?vue&type=script&lang=js&"
import style0 from "./study-participant-messages.vue?vue&type=style&index=0&id=494aee5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494aee5e",
  null
  
)

component.options.__file = "study-participant-messages.vue"
export default component.exports